import { render } from "./NotFound.vue?vue&type=template&id=2008821d"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"
script.render = render

export default script